export const TEAMSIDE_HOME = "*";
export const TEAMSIDE_AWAY = "/";

export const BALL_TYPE_HIGH = "H";
export const BALL_TYPE_MEDIUM = "M";
export const BALL_TYPE_QUICK = "Q";
export const BALL_TYPE_TENSE = "T";
export const BALL_TYPE_SUPER = "U";
export const BALL_TYPE_FAST = "N";
export const BALL_TYPE_OTHER = "O";

export const SKILL_CODE_SERVE = "S";
export const SKILL_CODE_RECEPTION = "R";
export const SKILL_CODE_ATTACK = "A";
export const SKILL_CODE_BLOCK = "B";
export const SKILL_CODE_DIG = "D";
export const SKILL_CODE_SET = "E";
export const SKILL_CODE_FREEBALL = "F";

export const EFFECT_CODE_ERROR = "=";
export const EFFECT_CODE_RETURNED = "/";
export const EFFECT_CODE_POOR = "-";
export const EFFECT_CODE_BLOCKED_RETURN = "!";
export const EFFECT_CODE_GOOD = "+";
export const EFFECT_CODE_EXCELLENT = "#";

export const SPECIAL_EVENT_TEAM_TIMEOUT = "T";
export const SPECIAL_EVENT_TECH_TIMEOUT = "TT";
export const SPECIAL_EVENT_SUBSTITUTION = "S";
export const SPECIAL_EVENT_LIBERO_IN_OUT = "L";
export const SPECIAL_EVENT_INJURY = "I";
export const SPECIAL_EVENT_RED_CARD = "R";
export const SPECIAL_EVENT_DOUBLE_RED = "RR";
export const SPECIAL_EVENT_DELAY_PENALTY = "DP";
export const SPECIAL_EVENT_YELLOW_CARD = "Y";
export const SPECIAL_EVENT_YELLOW_RED = "YR";
export const SPECIAL_EVENT_PROTEST = "P";
export const SPECIAL_EVENT_VIDEO_CHALLENGE = "V";
export const SPECIAL_EVENT_CHALLENGE_OVERTURNED = "VO";
export const SPECIAL_EVENT_CHALLENGE_UNSUCCESSFUL = "VU";
